import { render, staticRenderFns } from "./IndexPageTopCoverSection.vue?vue&type=template&id=b0fdeba2&scoped=true&"
import script from "./IndexPageTopCoverSection.vue?vue&type=script&lang=js&"
export * from "./IndexPageTopCoverSection.vue?vue&type=script&lang=js&"
import style0 from "./IndexPageTopCoverSection.vue?vue&type=style&index=0&id=b0fdeba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fdeba2",
  null
  
)

export default component.exports